import {
  Kbd,
  type KbdKey,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/react";
import { useEffect } from "react";

import { useDialog } from "@/contexts/DialogContext";

import { type IKeybind, KeybindManager } from "../lib/keybinds";
import { Button } from "./core/Button";

export const Keybind = ({ kb }: { kb: IKeybind }) => (
  <Kbd
    keys={(
      [
        kb.alt && "option",
        kb.ctrl && "ctrl",
        kb.meta && "command",
        kb.shift && "shift",
      ] as KbdKey[]
    ).filter((a) => a)}
  >
    {kb.key}
  </Kbd>
);

export const KeybindModal = () => {
  const { state, dispatch } = useDialog();

  useEffect(() => {
    const open = () =>
      dispatch({ action: "OPEN_DIALOG", dialog: { id: "KEYBINDS" } });

    KeybindManager.on("KEYBINDS", open);

    return () => {
      KeybindManager.off("KEYBINDS", open);
    };
  }, []);

  return (
    <Modal
      isOpen={"KEYBINDS" in state.dialogs}
      onOpenChange={() =>
        dispatch({ action: "CLOSE_DIALOG", dialogId: "KEYBINDS" })
      }
      placement="center"
      scrollBehavior="inside"
      classNames={{ wrapper: "overflow-hidden" }}
    >
      <ModalContent className="canvas-overlay-card max-h-[calc(100dvh-2rem)] overflow-hidden">
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Keybinds</ModalHeader>
            <ModalBody className="overflow-y-auto overscroll-contain">
              {Object.entries(KeybindManager.getKeybinds()).map(
                ([name, kbs]) => (
                  <div key={name} className="flex flex-row gap-2">
                    <span>{name}</span>
                    {kbs.map((kb, index) => (
                      <Keybind key={`${name}-${index}`} kb={kb} />
                    ))}
                  </div>
                ),
              )}
            </ModalBody>
            <ModalFooter>
              <Button onPress={onClose}>Close</Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
